//Internal state of the application
export const SET_COHORT_BUILDER_FORM_DATA = 'SET_COHORT_BUILDER_FORM_DATA'
export const SET_COHORT_BUILDER_FORM_DATA_LOADING = 'SET_COHORT_BUILDER_FORM_DATA_LOADING'
export const CLEAR_COHORT_BUILDER_FORM_DATA = 'CLEAR_COHORT_BUILDER_FORM_DATA'

//Form Response
export const SET_COHORT_FORM_RESPONSE = 'SET_COHORT_FORM_RESPONSE'
export const SET_COHORT_FORM_RESPONSE_LOADING = 'SET_COHORT_FORM_RESPONSE_LOADING'
export const CLEAR_COHORT_FORM_RESPONSE = 'CLEAR_COHORT_FORM_RESPONSE'
